import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleRequest } from '../quipli-service-client';
import { DispatchStatusUpdateRequest } from './dispatch';
import { Dispatch } from '../order/order';
import { OrderParsers } from '../order/order-parsers';

export const useDispatchApiV1 = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function transition(request: DispatchStatusUpdateRequest): Promise<Dispatch> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/dispatch/transition`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    return OrderParsers.toDispatch(await handleRequest(config));
  }

  async function getDispatch(orderId: number): Promise<Dispatch> {
    const config = {
      method: 'get',
      url: `${contextPath}quipli-service/v1/dispatch/${orderId}`,
      headers: {
        'X-Tenant': tenant,
      },
    };
    return OrderParsers.toDispatch(await handleRequest(config));
  }

  return { transition, getDispatch };
};
